/**
 * main.js
 * http://www.codrops.com
 *
 * Licensed under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
 * 
 * Copyright 2015, Codrops
 * http://www.codrops.com
 */
;(function(window) {

	'use strict';

	var support = { transitions: Modernizr.csstransitions },
		// transition end event name
		transEndEventNames = { 'WebkitTransition': 'webkitTransitionEnd', 'MozTransition': 'transitionend', 'OTransition': 'oTransitionEnd', 'msTransition': 'MSTransitionEnd', 'transition': 'transitionend' },
		transEndEventName = transEndEventNames[ Modernizr.prefixed( 'transition' ) ],
		onEndTransition = function( el, callback ) {
			var onEndCallbackFn = function( ev ) {
				if( support.transitions ) {
					if( ev.target != this ) return;
					this.removeEventListener( transEndEventName, onEndCallbackFn );
				}
				if( callback && typeof callback === 'function' ) { callback.call(this); }
			};
			if( support.transitions ) {
				el.addEventListener( transEndEventName, onEndCallbackFn );
			}
			else {
				onEndCallbackFn();
			}
		},
		// the pages wrapper
		stack = document.querySelector('.pages-stack'),
		// the page elements
		pages = [].slice.call(stack.children),
		// total number of page elements
		pagesTotal = pages.length,
		// index of current page
		current = 0,
		// menu button
		menuCtrl = document.querySelector('button.menu-trigger'),
		// the navigation wrapper
		nav = document.querySelector('.pages-nav'),
		bodyLnks = document.querySelector('.lnks'),
		// the menu nav items
		navItems = [].slice.call(bodyLnks.querySelectorAll('.link--page')),
		// check if menu is open
		isMenuOpen = false;


		var navMenu = document.querySelector('#navMenu');
		var bottomSoc = document.querySelector('.bottom-socials');
		var mainHeader = document.querySelector('.main-header');

	function init() {
		buildStack();
		initEvents();
	}

	function buildStack() {
		var stackPagesIdxs = getStackPagesIdxs();

		// set z-index, opacity, initial transforms to pages and add class page--inactive to all except the current one
		for(var i = 0; i < pagesTotal; ++i) {
			var page = pages[i],
				posIdx = stackPagesIdxs.indexOf(i);

			if( current !== i ) {
				classie.add(page, 'page--inactive');

				if( posIdx !== -1 ) {
					// visible pages in the stack
					page.style.WebkitTransform = 'translate3d(0,100%,0)';
					page.style.transform = 'translate3d(0,100%,0)';
				}
				else {
					// invisible pages in the stack
					page.style.WebkitTransform = 'translate3d(0,90%,-500px)';
					page.style.transform = 'translate3d(0,90%,-500px)';
				}
			}
			else {
				classie.remove(page, 'page--inactive');
			}

			page.style.zIndex = i < current ? parseInt(current - i) : parseInt(pagesTotal + current - i);
			
			if( posIdx !== -1 ) {
				page.style.opacity = parseFloat(1 - 0.1 * posIdx);
			}
			else {
				page.style.opacity = 0;
			}
		}
	}

	// event binding
	function initEvents() {
		// menu button click
		menuCtrl.addEventListener('click', toggleMenu);

		// navigation menu clicks
		navItems.forEach(function(item) {
			// which page to open?
			var pageid = item.getAttribute('href').slice(1);
			item.addEventListener('click', function(ev) {
				if ($(item).hasClass('in-home')) {
                    ev.preventDefault();
                    openPage('');
				}
				if ($(item).hasClass('link-scroll') && $(item).hasClass('curr-page')) {
					var idattr = item.getAttribute('href').split('#')[1];
                    ev.preventDefault();
                    openPage('');
                    if (($('#page-vitafruit').length > 0)) {
                        setTimeout(function(){
                            var offsetas = $("#" + idattr).position();
                            $('#page-vitafruit').animate({
                                scrollTop: offsetas.top
                            }, 400);
                            window.location.hash = idattr;
						}, 500);
                    }
                    if (($('#page-active').length > 0)) {
                        setTimeout(function(){
                            var offsetas = $("#" + idattr).position();
                            $('#page-active').animate({
                                scrollTop: offsetas.top
                            }, 400);
                            window.location.hash = idattr;
                        }, 500);
                    }
				}
			});
		});

		// clicking on a page when the menu is open triggers the menu to close again and open the clicked page
		pages.forEach(function(page) {
			var pageid = page.getAttribute('id');
			page.addEventListener('click', function(ev) {
				if( isMenuOpen ) {
					ev.preventDefault();
					openPage(pageid);
				}
			});
		});

		// keyboard navigation events
		document.addEventListener( 'keydown', function( ev ) {
			if( !isMenuOpen ) return; 
			var keyCode = ev.keyCode || ev.which;
			if( keyCode === 27 ) {
				closeMenu();
			}
		} );
	}

	// toggle menu fn
	function toggleMenu() {
		if( isMenuOpen ) {
			closeMenu();
		}
		else {
			openMenu();
			isMenuOpen = true;
		}
	}

	// opens the menu
	function openMenu() {
		if ($('html').hasClass('fp-enabled')) {
			$.fn.fullpage.setAllowScrolling(false);
			$.fn.fullpage.setKeyboardScrolling(false);
		}
		// toggle the menu button
		classie.add(menuCtrl, 'menu-trigger--open');
		// stack gets the class "pages-stack--open" to add the transitions
		classie.add(stack, 'pages-stack--open');
		// reveal the menu
		classie.add(nav, 'pages-nav--open');

		if (navMenu) {
            classie.add(navMenu, 'pages-nav--open');
		}
        if (bottomSoc) {
            classie.add(bottomSoc, 'menu-opened');
        }
		classie.add(mainHeader, 'menu-opened');

		$('#page-vitafruit').addClass('fixed');
		$('#page-active').addClass('fixed');

		$('#fullpage').addClass('mn-op');

		// now set the page transforms
		var stackPagesIdxs = getStackPagesIdxs();
		for(var i = 0, len = stackPagesIdxs.length; i < len; ++i) {
			var page = pages[stackPagesIdxs[i]];
			if ($(window).width() > 768) {
				page.style.WebkitTransform = 'translate3d(0, ' + parseInt(90 + 5*i) + '%, ' + parseInt(-1 * 200 - 80*i) + 'px)'; // -200px, -230px, -260px
				page.style.transform = 'translate3d(0, ' + parseInt(90 + 5*i) + '%, ' + parseInt(-1 * 200 - 80*i) + 'px)';
			} else if ($(window).width() > 600) {
				page.style.WebkitTransform = 'translate3d(0, ' + parseInt(90 + 5*i) + '%, ' + parseInt(-1 * 200 - 80*i) + 'px)'; // -200px, -230px, -260px
				page.style.transform = 'translate3d(0, ' + parseInt(90 + 5*i) + '%, ' + parseInt(-1 * 200 - 80*i) + 'px)';
			} else {
				page.style.WebkitTransform = 'translate3d(0, ' + parseInt(115 + 10*i) + '%, ' + parseInt(-1 * 200 - 100*i) + 'px)'; // -200px, -230px, -260px
				page.style.transform = 'translate3d(0, ' + parseInt(115 + 10*i) + '%, ' + parseInt(-1 * 200 - 100*i) + 'px)';
			}
		}
	}

	// closes the menu
	function closeMenu() {
		// same as opening the current page again
		openPage();

        if (!($('#product-slider').hasClass('info-opened'))) {
            $('#page-vitafruit').removeClass('fixed');
            $('#page-active').removeClass('fixed');
        }

		if (($('#owl-example').hasClass('info-opened'))) {
			if ($('html').hasClass('fp-enabled')) {
				$.fn.fullpage.setAllowScrolling(false);
				$.fn.fullpage.setKeyboardScrolling(false);
			}
		} else {
			if ($('html').hasClass('fp-enabled')) {
				$.fn.fullpage.setAllowScrolling(true);
				$.fn.fullpage.setKeyboardScrolling(true);
			}
		}
	}

	// opens a page
	function openPage(id) {
		var futurePage = id ? document.getElementById(id) : pages[current],
			futureCurrent = pages.indexOf(futurePage),
			stackPagesIdxs = getStackPagesIdxs(futureCurrent);

		// set transforms for the new current page
		futurePage.style.WebkitTransform = 'translate3d(0, 0, 0)';
		futurePage.style.transform = 'translate3d(0, 0, 0)';
		futurePage.style.opacity = 1;

		// set transforms for the other items in the stack
		for(var i = 0, len = stackPagesIdxs.length; i < len; ++i) {
			var page = pages[stackPagesIdxs[i]];
			page.style.WebkitTransform = 'translate3d(0,100%,0)';
			page.style.transform = 'translate3d(0,100%,0)';
		}

		// set current
		if( id ) {
			current = futureCurrent;
		}
		
		// close menu..
		if (isMenuOpen) {
			classie.remove(menuCtrl, 'menu-trigger--open');
			classie.remove(nav, 'pages-nav--open');
			onEndTransition(futurePage, function() {
				classie.remove(stack, 'pages-stack--open');
                if (navMenu) {
                    classie.remove(navMenu, 'pages-nav--open');
                }
                if (bottomSoc) {
                    classie.remove(bottomSoc, 'menu-opened');
                }
				if (!($('#product-slider').hasClass('info-opened'))) {
					classie.remove(mainHeader, 'menu-opened');
				}
				// reorganize stack
				buildStack();
                isMenuOpen = false;
			});
			$('#fullpage').removeClass('mn-op');

            if (!($('#product-slider').hasClass('info-opened'))) {
                $('#page-vitafruit').removeClass('fixed');
                $('#page-active').removeClass('fixed');
			}
		}

		if ($('html').hasClass('fp-enabled')) {
			$.fn.fullpage.setAllowScrolling(true);
			$.fn.fullpage.setKeyboardScrolling(true);
		}
	}

	// gets the current stack pages indexes. If any of them is the excludePage then this one is not part of the returned array
	function getStackPagesIdxs(excludePageIdx) {
		var nextStackPageIdx = current + 1 < pagesTotal ? current + 1 : 0,
			nextStackPageIdx_2 = current + 2 < pagesTotal ? current + 2 : 1,
			idxs = [],

			excludeIdx = excludePageIdx || -1;

		if( excludePageIdx != current ) {
			idxs.push(current);
		}
		if( excludePageIdx != nextStackPageIdx ) {
			idxs.push(nextStackPageIdx);
		}
		if( excludePageIdx != nextStackPageIdx_2 ) {
			idxs.push(nextStackPageIdx_2);
		}

		return idxs;
	}

	init();

})(window);